import { AxiosInstance } from "axios";
import { OperationAlertDto } from "../types/alert/operation-alert-dto";
import { ongBaseApi } from "./ong-base-api";
import { OngBaseResponse } from "./ong-base-response";

export enum AlertApiUrl {
  getAll = "/redis/operation-alerts",
}

class AlertApi {
  private _api: AxiosInstance;

  constructor(api: AxiosInstance) {
    this._api = api;
  }

  async getAll(): Promise<OngBaseResponse<OperationAlertDto>> {
    return await this._api.get(AlertApiUrl.getAll);
  }
}

export const alertApi = new AlertApi(ongBaseApi);
